export const getStatusType = (status: string) => {
  switch (status) {
    case "DRAFT":
      return {title: "Draft", type: "draft"};
    case "RETURNED_TO_HUB":
      return {title: "Returned to hub", type: "draft"};
    case "REDELIVERY":
      return {title: "Redelivery", type: "draft"};
    case "ENROUTE_TO_PICKUP":
      return {title: "Enroute to Pickup", type: "pickup"};
    case "PICKUP_SCHEDULED":
      return {title: "Pick Up Scheduled", type: "pickup"};
    case "PICKEDUP":
      return {title: "Package Picked Up", type: "pickup"};
    case "REFUND_INITIATED":
      return {title: "Refund Initiated", type: "pickup"};
    case "PACKAGE_AT_HUB":
      return {title: "Enroute to Hub", type: "hub"};
    case "IN_HUB":
      return {title: "In Hub", type: "hub"};
    case "ASSIGNED":
      return {title: "Assigned", type: "hub"};
    case "PENDING":
      return {title: "Pending", type: "pending"};
    case "RE_ASSIGNING":
      return {title: "Reassigning", type: "pending"};
    case "TOPUP_REQUESTED":
      return {title: "Topup Requested", type: "failed"};
    case "ENROUTE_TO_DELIVERY":
      return {title: "Enroute to Delivery", type: "delivery"};
    case "EXECUTING":
      return {title: "Executing", type: "delivery"};
    case "COMPLETED":
      return {title: "Completed", type: "success"};
    case "DELIVERED":
      return {title: "Delivered", type: "success"};
    case "SUCCESS":
      return {title: "Success", type: "success"};
    case "REFUND_COMPLETED":
      return {title: "Refund Completed", type: "success"};
    case "CANCELLED":
      return {title: "Cancelled", type: "failed"};
    case "DELIVERY_FAILED":
      return {title: "Delivery Failed", type: "failed"};
    case "PICKUP_FAILED":
      return {title: "Pickup Failed", type: "failed"};
    case "FAILED":
      return {title: "Failed", type: "failed"};
    case "DELAYED":
      return {title: "Delayed", type: "failed"};
    default:
      return {title: status, type: "pending"};
  }
};
